import axios from "./axiosInstance";

const OurTeamAPI = {
  getOurTeam: () => axios.get(`/our-team`),
};

export default OurTeamAPI;